// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"8d18cdb6","143":"cd56bd9a"}[chunkId] + ".chunk.css";
};